/* Crank the manta ray: a canvas toy version of the wooden automaton. No libraries. */
(function () {
  var LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var DICT = {
    ru: {
      'Gear turning. Watch the wings take turns.': 'Шестерёнка крутится. Смотрите, как крылья машут по очереди.',
      'It flies! One flap.': 'Летит! Один взмах.',
      'Eight flaps. The wings take turns: left, right, tail.': 'Восемь взмахов. Крылья машут по очереди: левое, правое, хвост.',
      'Twenty! Real wood and wire, no batteries needed to flap.': 'Двадцать! Настоящее дерево и проволока, батарейки для взмахов не нужны.',
      'Fast! Look at the bubbles.': 'Быстро! Смотрите, сколько пузырьков.',
      ' (Motion is reduced: it moves only when you turn the gear.)': ' (Анимация уменьшена: скат движется, только когда вы крутите шестерёнку.)'
    },
    de: {
      'Gear turning. Watch the wings take turns.': 'Das Zahnrad dreht sich. Sehen Sie, wie die Flügel abwechselnd schlagen.',
      'It flies! One flap.': 'Er fliegt! Ein Flügelschlag.',
      'Eight flaps. The wings take turns: left, right, tail.': 'Acht Flügelschläge. Die Flügel schlagen abwechselnd: links, rechts, Schwanz.',
      'Twenty! Real wood and wire, no batteries needed to flap.': 'Zwanzig! Echtes Holz und Draht, zum Flattern braucht es keine Batterien.',
      'Fast! Look at the bubbles.': 'Schnell! Sehen Sie sich die Blasen an.',
      ' (Motion is reduced: it moves only when you turn the gear.)': ' (Bewegung reduziert: Er bewegt sich nur, wenn Sie das Zahnrad drehen.)'
    },
    es: {
      'Gear turning. Watch the wings take turns.': 'El engranaje gira. Mire cómo las alas se turnan.',
      'It flies! One flap.': '¡Vuela! Un aleteo.',
      'Eight flaps. The wings take turns: left, right, tail.': 'Ocho aleteos. Las alas se turnan: izquierda, derecha, cola.',
      'Twenty! Real wood and wire, no batteries needed to flap.': '¡Veinte! Madera y alambre de verdad, no hacen falta pilas para aletear.',
      'Fast! Look at the bubbles.': '¡Rápido! Mire las burbujas.',
      ' (Motion is reduced: it moves only when you turn the gear.)': ' (Movimiento reducido: solo se mueve cuando gira el engranaje.)'
    },
    fr: {
      'Gear turning. Watch the wings take turns.': 'L\u2019engrenage tourne. Regardez les ailes battre chacune à leur tour.',
      'It flies! One flap.': 'Il vole ! Un battement.',
      'Eight flaps. The wings take turns: left, right, tail.': 'Huit battements. Les ailes battent à tour de rôle : gauche, droite, queue.',
      'Twenty! Real wood and wire, no batteries needed to flap.': 'Vingt ! Du vrai bois et du fil de fer, pas besoin de piles pour battre des ailes.',
      'Fast! Look at the bubbles.': 'Vite ! Regardez les bulles.',
      ' (Motion is reduced: it moves only when you turn the gear.)': ' (Mouvement réduit : il ne bouge que lorsque vous tournez l\u2019engrenage.)'
    },
    ar: {
      'Gear turning. Watch the wings take turns.': 'الترس يدور. شاهد الأجنحة تتحرك بالتناوب.',
      'It flies! One flap.': 'إنه يطير! رفرفة واحدة.',
      'Eight flaps. The wings take turns: left, right, tail.': 'ثماني رفرفات. الأجنحة تتحرك بالتناوب: اليسرى، اليمنى، الذيل.',
      'Twenty! Real wood and wire, no batteries needed to flap.': 'عشرون! خشب وسلك حقيقيان، ولا حاجة إلى بطاريات للرفرفة.',
      'Fast! Look at the bubbles.': 'بسرعة! انظر إلى الفقاعات.',
      ' (Motion is reduced: it moves only when you turn the gear.)': ' (الحركة مخفّضة: لا يتحرك إلا عندما تدير الترس.)'
    }
  };
  function T(s, v) { var o = (DICT[LANG] || {})[s] || s; if (v) for (var k in v) o = o.split('{' + k + '}').join(v[k]); return o; }
  function init(root) {
    var cv = root.querySelector('[data-cv]'), ctx = cv.getContext('2d');
    var flapsEl = root.querySelector('[data-flaps]'), msg = root.querySelector('[data-msg]');
    var autoBtn = root.querySelector('[data-auto]'), resetBtn = root.querySelector('[data-reset]');
    var hint = root.getAttribute('data-hint') || '';
    var W = 400, GX = 205, GY = 318, GR = 38;
    var theta = 0, omega = 0, total = 0, auto = false, drag = false, lastAng = 0, lastT = 0, vis = true, raf = 0, prev = 0;
    var bubbles = [], lanterns = [], plankton = [], ripples = [], said = {};
    var TAU = Math.PI * 2;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i;
    for (i = 0; i < 7; i++) lanterns.push({ x: 30 + Math.random() * 340, y: 40 + Math.random() * 300, s: 5 + Math.random() * 6, v: 3 + Math.random() * 5, ph: Math.random() * 6 });
    for (i = 0; i < 40; i++) plankton.push({ x: Math.random() * W, y: Math.random() * W, r: .6 + Math.random() * 1.4, ph: Math.random() * 6 });

    function fit() {
      var r = cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2), px = Math.round(r.width * d) || 800;
      if (cv.width !== px) { cv.width = px; cv.height = px; }
    }
    function say(t) { msg.textContent = t; }
    function setFlaps() { flapsEl.textContent = Math.floor(total / TAU); }

    function pos(e) {
      var r = cv.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * W };
    }
    function down(e) {
      var p = pos(e), dx = p.x - GX, dy = p.y - GY;
      try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      if (Math.sqrt(dx * dx + dy * dy) < GR + 26) {
        drag = true; cv.classList.add('is-drag'); lastAng = Math.atan2(dy, dx); lastT = performance.now(); auto = false; autoBtn.classList.remove('is-on');
      } else {
        omega = Math.min(omega + 3.2, 9); ripples.push({ x: p.x, y: p.y, t: 0 });
      }
      e.preventDefault();
    }
    function move(e) {
      if (!drag) return;
      var p = pos(e), ang = Math.atan2(p.y - GY, p.x - GX), da = ang - lastAng, now = performance.now(), dt = Math.max(8, now - lastT) / 1000;
      if (da > Math.PI) da -= TAU; if (da < -Math.PI) da += TAU;
      theta += da; total += Math.abs(da); omega = omega * .6 + (da / dt) * .4; lastAng = ang; lastT = now; setFlaps(); e.preventDefault();
    }
    function up() { drag = false; cv.classList.remove('is-drag'); }
    cv.addEventListener('pointerdown', down); cv.addEventListener('pointermove', move);
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up); cv.addEventListener('pointerleave', function () { if (drag) up(); });

    autoBtn.addEventListener('click', function () {
      auto = !auto; autoBtn.classList.toggle('is-on', auto); if (auto) say(T('Gear turning. Watch the wings take turns.')); else say(hint);
    });
    resetBtn.addEventListener('click', function () { theta = 0; omega = 0; total = 0; auto = false; autoBtn.classList.remove('is-on'); bubbles = []; said = {}; setFlaps(); say(hint); });

    function wrapA(a) { return a; }

    function rr(x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

    function draw(t) {
      var s = cv.width / W, k, g;
      ctx.setTransform(s, 0, 0, s, 0, 0);
      g = ctx.createLinearGradient(0, 0, 0, W); g.addColorStop(0, '#1a5568'); g.addColorStop(.55, '#0f2c3f'); g.addColorStop(1, '#08121d');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);
      // soft light rays
      ctx.save(); ctx.globalAlpha = .07; ctx.fillStyle = '#bff3ff';
      for (k = 0; k < 4; k++) { ctx.beginPath(); ctx.moveTo(60 + k * 95, 0); ctx.lineTo(100 + k * 95, 0); ctx.lineTo(10 + k * 95 + Math.sin(t / 2600 + k) * 18, W); ctx.lineTo(-40 + k * 95, W); ctx.closePath(); ctx.fill(); }
      ctx.restore();
      // plankton
      plankton.forEach(function (p) { ctx.globalAlpha = .25 + .35 * Math.abs(Math.sin(t / 900 + p.ph)); ctx.fillStyle = '#d9fbff'; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, TAU); ctx.fill(); });
      ctx.globalAlpha = 1;
      // lanterns
      lanterns.forEach(function (l) {
        var gl = ctx.createRadialGradient(l.x, l.y, 0, l.x, l.y, l.s * 4); gl.addColorStop(0, 'rgba(255,220,130,.55)'); gl.addColorStop(1, 'rgba(255,220,130,0)');
        ctx.fillStyle = gl; ctx.beginPath(); ctx.arc(l.x, l.y, l.s * 4, 0, TAU); ctx.fill();
        ctx.fillStyle = '#ffd98a'; rr(l.x - l.s * .6, l.y - l.s * .8, l.s * 1.2, l.s * 1.6, l.s * .4); ctx.fill();
      });
      // ripples
      ripples.forEach(function (r) { ctx.strokeStyle = 'rgba(190,240,255,' + (1 - r.t) * .6 + ')'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(r.x, r.y, 6 + r.t * 40, 0, TAU); ctx.stroke(); });
      // bubbles
      bubbles.forEach(function (b) { ctx.strokeStyle = 'rgba(200,245,255,' + Math.min(1, b.l) * .8 + ')'; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.arc(b.x, b.y, b.r, 0, TAU); ctx.stroke(); });

      // mechanism numbers
      var sl = Math.sin(theta), sr = Math.sin(theta - 0.9), sb = Math.sin(theta - 0.45), st = Math.sin(theta - 1.6);
      var A = 38, by = 150 + sb * 7;
      var wl = 150 + sl * A, wr = 150 + sr * A, tl = by + 92 + st * 6;
      var pl = 296 + sl * 6, pr = 296 + sr * 6;

      // wires and rod
      ctx.strokeStyle = 'rgba(230,236,240,.8)'; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.moveTo(170, pl); ctx.lineTo(112, wl + 4); ctx.moveTo(176, pl); ctx.lineTo(132, wl + 14);
      ctx.moveTo(240, pr); ctx.lineTo(288, wr + 4); ctx.moveTo(234, pr); ctx.lineTo(268, wr + 14); ctx.stroke();
      ctx.strokeStyle = '#2a2420'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(205, 298); ctx.lineTo(205, by + 34); ctx.stroke();
      // dark post behind the rod
      ctx.fillStyle = '#3a2a22'; ctx.fillRect(196, 232, 7, 66);

      // manta ray
      ctx.save();
      g = ctx.createLinearGradient(60, by - 20, 340, by + 80); g.addColorStop(0, '#a6683d'); g.addColorStop(.5, '#6d3f27'); g.addColorStop(1, '#a6683d');
      ctx.fillStyle = g; ctx.strokeStyle = '#3a2216'; ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(205, by - 20);
      ctx.quadraticCurveTo(130, wl - 36, 52, wl - 12);
      ctx.quadraticCurveTo(110, wl + 26, 172, by + 34);
      ctx.lineTo(205, tl + 14); ctx.lineTo(238, by + 34);
      ctx.quadraticCurveTo(300, wr + 26, 358, wr - 12);
      ctx.quadraticCurveTo(280, wr - 36, 205, by - 20);
      ctx.closePath(); ctx.fill(); ctx.stroke();
      // wing veins
      ctx.strokeStyle = 'rgba(40,22,12,.45)'; ctx.lineWidth = 1;
      for (k = 1; k < 5; k++) {
        ctx.beginPath(); ctx.moveTo(190, by + 6 + k * 5); ctx.quadraticCurveTo(130, wl + k * 4, 64 + k * 8, wl - 4 + k * 3); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(220, by + 6 + k * 5); ctx.quadraticCurveTo(280, wr + k * 4, 346 - k * 8, wr - 4 + k * 3); ctx.stroke();
      }
      // head fins and eyes
      ctx.fillStyle = '#5b3320'; ctx.beginPath(); ctx.moveTo(190, by - 16); ctx.lineTo(180, by - 30 + sb * 2); ctx.lineTo(197, by - 6); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.moveTo(220, by - 16); ctx.lineTo(230, by - 30 + sb * 2); ctx.lineTo(213, by - 6); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#f3e6d0'; ctx.beginPath(); ctx.arc(194, by + 2, 2.2, 0, TAU); ctx.arc(216, by + 2, 2.2, 0, TAU); ctx.fill();
      ctx.strokeStyle = '#2a1a10'; ctx.lineWidth = 1.6; ctx.beginPath(); ctx.moveTo(205, tl + 12); ctx.lineTo(205 + Math.sin(theta - 2) * 6, tl + 44); ctx.stroke();
      ctx.restore();

      // wooden box + plinth
      ctx.fillStyle = '#4a3023'; rr(130, 350, 150, 18, 4); ctx.fill();
      g = ctx.createLinearGradient(0, 296, 0, 350); g.addColorStop(0, '#e2b778'); g.addColorStop(1, '#c58f4f');
      ctx.fillStyle = g; rr(150, 296, 110, 56, 4); ctx.fill();
      ctx.strokeStyle = 'rgba(80,45,20,.35)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(160, 318); ctx.lineTo(250, 318); ctx.stroke();
      // gear
      ctx.save(); ctx.translate(GX, GY); ctx.rotate(theta);
      var n = 12, ri = GR - 3, ro = GR + 7; ctx.beginPath();
      for (k = 0; k < n; k++) {
        var a0 = k / n * TAU, a1 = a0 + TAU / n * .25, a2 = a0 + TAU / n * .5, a3 = a0 + TAU / n * .75;
        ctx.lineTo(Math.cos(a0) * ri, Math.sin(a0) * ri); ctx.lineTo(Math.cos(a1) * ro, Math.sin(a1) * ro); ctx.lineTo(Math.cos(a2) * ro, Math.sin(a2) * ro); ctx.lineTo(Math.cos(a3) * ri, Math.sin(a3) * ri);
      }
      ctx.closePath(); ctx.fillStyle = '#ffd400'; ctx.fill(); ctx.strokeStyle = '#b08f00'; ctx.lineWidth = 1.5; ctx.stroke();
      ctx.fillStyle = 'rgba(255,255,255,.35)'; ctx.beginPath(); ctx.arc(-8, -10, 14, 0, TAU); ctx.fill();
      ctx.fillStyle = '#b08f00'; ctx.beginPath(); ctx.arc(0, 0, 5, 0, TAU); ctx.fill();
      ctx.fillStyle = '#c98f4f'; ctx.strokeStyle = '#7a4a22'; ctx.beginPath(); ctx.arc(GR - 14, 0, 6.5, 0, TAU); ctx.fill(); ctx.stroke();
      ctx.restore();
      if (!drag && total < 1) {
        ctx.save(); ctx.globalAlpha = .55 + .35 * Math.sin(t / 260); ctx.strokeStyle = '#fff'; ctx.lineWidth = 2; ctx.setLineDash([5, 6]);
        ctx.beginPath(); ctx.arc(GX, GY, GR + 16, 0, TAU); ctx.stroke(); ctx.restore();
      }
    }

    function step(t) {
      var dt = Math.min(.05, (t - prev) / 1000 || .016); prev = t;
      if (!drag) {
        if (auto) omega += (3.6 - omega) * Math.min(1, dt * 2.2); else omega *= Math.pow(.18, dt);
        if (Math.abs(omega) < .02) omega = 0;
        var d = omega * dt; theta += d; total += Math.abs(d); setFlaps();
      }
      var n = Math.floor(total / TAU), sp = Math.abs(omega);
      if (n >= 1 && !said.a) { said.a = 1; say(T('It flies! One flap.')); }
      if (n >= 8 && !said.b) { said.b = 1; say(T('Eight flaps. The wings take turns: left, right, tail.')); }
      if (n >= 20 && !said.c) { said.c = 1; say(T('Twenty! Real wood and wire, no batteries needed to flap.')); }
      if (sp > 6 && !said.d) { said.d = 1; say(T('Fast! Look at the bubbles.')); }
      if (sp > .4 && Math.random() < Math.min(.5, sp * .05)) bubbles.push({ x: 190 + Math.random() * 30, y: 150 + Math.random() * 20, r: 2 + Math.random() * 3.5, v: 25 + Math.random() * 30, l: 1.4 });
      bubbles.forEach(function (b) { b.y -= b.v * dt; b.x += Math.sin(b.y / 14) * .3; b.l -= dt * .5; });
      bubbles = bubbles.filter(function (b) { return b.l > 0 && b.y > -10; });
      ripples.forEach(function (r) { r.t += dt * 1.4; }); ripples = ripples.filter(function (r) { return r.t < 1; });
      lanterns.forEach(function (l) { l.y -= l.v * dt; l.x += Math.sin(t / 1800 + l.ph) * .15; if (l.y < -20) { l.y = W + 10; l.x = 30 + Math.random() * 340; } });
      fit(); draw(t);
      raf = vis ? requestAnimationFrame(step) : 0;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { vis = en[0].isIntersecting; if (vis && !raf) { prev = performance.now(); raf = requestAnimationFrame(step); } }).observe(cv);
    }
    window.addEventListener('resize', fit);
    fit(); say(hint); raf = requestAnimationFrame(step);
    if (reduce) say(hint + T(' (Motion is reduced: it moves only when you turn the gear.)'));
  }
  function boot() { var r = document.querySelectorAll('[data-pmanta]'), k; for (k = 0; k < r.length; k++) init(r[k]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
